<template>
  <div style="margin: 4px 16px 16px;">
    <div class="content-input" style="margin-bottom: 8px;">
      <div class="content-input-left">
        <div class="dialog-input-item">
          <label>物种</label>
          <el-select v-model="petType" placeholder="Select" class="select-item" @change="petTypeChange">
            <el-option v-for="item in petTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <label style="width: 6em">保障提交时间</label>
          <DatePickerRange title="" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="dialog-input-item">
          <label>品种</label>
          <el-select v-model="breedId" placeholder="Select" class="select-item" @change="breedIdChange">
            <el-option v-for="item in breedIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <label>花色</label>
          <el-select v-model="breedColorId" placeholder="Select" class="select-item">
            <el-option v-for="item in breedColorIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <label style="width: 6em">剩余保障天数</label>
          <el-input v-model="validDayMin" placeholder="最低余额"></el-input>
          <span style="margin: 0 4px">-</span>
          <el-input v-model="validDayMax" placeholder="最高余额"></el-input>
        </div>
        <div class="dialog-input-item">
          <label>状态</label>
          <el-select v-model="expireState" placeholder="Select" class="select-item">
            <el-option v-for="item in expireStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>


        <div class="dialog-input-item">
          <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
          <el-checkbox v-model="limitState" style="margin-left: 8px"><span style="white-space: nowrap">有限制</span></el-checkbox>
        </div>
      </div>

      <div class="content-input-right">
        <div class="dialog-input-btn">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
        </div>
        <div class="dialog-input-btn">
           <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        v-loading="listLoading"
        @cell-click="toggleSelection"
        size="default"
        border
    >
      <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
      <el-table-column property="createTime" label="保障提交时间"/>
      <el-table-column property="" label="主人信息">
        <template #default="scope">
          <p>主人：{{scope.row.userName}}</p>
          <p>性别：{{scope.row.userSex == 1?'男':scope.row.userSex == 2?'女':''}}</p>
          <p>手机：{{scope.row.phone}}</p>
        </template>
      </el-table-column>
      <el-table-column property="projectAllContent" label="宠物信息">
        <template #default="scope">
          <p>物种：{{scope.row.petType == 1?'猫咪':scope.row.petType == 2?'狗':''}}</p>
          <p>品种：{{scope.row.petBreedName}}</p>
          <p>花色：{{scope.row.petBreedColorName}}</p>
          <p>名称：{{scope.row.petName}}</p>
          <p>性别：{{scope.row.petSex == 1?'弟弟':scope.row.petSex == 2?'妹妹':''}}</p>
          <p>年龄：{{scope.row.petAgeMonth.age}}岁{{scope.row.petAgeMonth.month}}个月</p>
        </template>
      </el-table-column>
      <el-table-column property="validDay" label="剩余保障天数" />
      <el-table-column property="remark" label="备注" />
    </el-table>
    <!--分页-->
    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '@/api/api';
import {getAllPetBreedList, getSecurityDetailPageList,} from '@/api/url';
import Dialog from '@/assets/js/dialog'
import DatePickerRange from "@/components/DatePickerRange";
import SearchComponents from "@/components/SearchComponents";
import remarkDialog from "@/views/medical/components/remarkDialog";
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange, SearchComponents},
  data() {
    return {
      userAppletId: this.value.userAppletId,
      pageDataList: [],
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,

      petTypeArray: [
        {label: '不限', value: -1},
        {label: '喵咪', value: 1},
        {label: '狗', value: 2}
      ],
      petType: -1,

      allBreedList: [],

      breedIdArray: [
        {name: '不限', id: 0},
      ],
      breedId: 0,

      breedColorIdArray: [
        {name: '不限', id: 0},
      ],
      breedColorId: 0,

      expireStateArray: [
        {label: '不限', value: -1},
        {label: '已过期', value: 1},
        {label: '未过期', value: 2},
      ],
      expireState: -1,

      //消费时间
      startTime: '',
      endTime: '',
      isChecked: true,

      validDayMax: '',
      validDayMin: '',

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '主人ID', value : 3},
      ],
      searchType: 1,
      searchValue: '',

      shopIdArray: [],
      shopIdArr:[],
      shopId: 0,

      limitState: true,
    }
  },
  methods: {

    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.petType = -1;
      this.breedId = 0;
      this.breedColorId = 0;
      this.expireState = -1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['userAppletId'] = this.userAppletId;
      param['expireState'] = this.expireState;
      param['petType'] = this.petType;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['petBreedId'] = this.breedId;
      param['petBreedColorId'] = this.breedColorId;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['validDayMin'] = this.validDayMin;
      param['validDayMax'] = this.validDayMax;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getSecurityDetailPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    getAllPetList() {
      getFormData(getAllPetBreedList).then(data => {
        let {msg, code} = data
        if (code == 200) {
          this.allBreedList = data.data
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    petTypeChange(val) {
      console.log(val)
      this.breedIdArray = [
        {name: '不限', id: 0},
      ]
      let list = this.allBreedList.filter(item => item.type == val)
      console.log(list)
      this.breedIdArray = [...this.breedIdArray, ...list]
    },

    breedIdChange(val) {
      this.breedColorIdArray = [
        {name: '不限', id: 0},
      ]
      this.breedIdArray.map(item => {
        if(item.id == val) {
          this.breedColorIdArray = [...this.breedColorIdArray, ...item.petBreedColorList]
        }
      })
    },


    toggleSelection(row, column, cell, event) {
      if(column.label == '备注') {
        let remarkForm = Object.assign({}, row);
        Dialog.open({
          title: '更新备注',
          component: remarkDialog,
          data: {
            remarkForm: remarkForm,
            width: '500px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

    }


  },
  mounted() {
    this.getAllPetList()
    this.getPage();
  }
}
</script>

<style>

</style>
